"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _occasion = _interopRequireDefault(require("occasion"));
var _row = _interopRequireDefault(require("../../../../core/row"));
var _col = _interopRequireDefault(require("../../../../core/col"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "Please Wait");
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "Please confirm that this correct");
class ConfirmPukMembership extends _react.Component {
  render() {
    const scratchPaddler = this.props.scratchPaddler;
    const member = this.props.member;
    const col1 = '6';
    const col2 = '6';
    if (!member || !scratchPaddler) return _ref;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref2, /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col1
    }, "Membership Name:"), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col2
    }, member.firstName, " ", member.lastName)), member.firstName + ' ' + member.lastName === scratchPaddler.paddlerName ? null : /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col1
    }, "To be Shown As:"), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col2
    }, scratchPaddler.paddlerName)), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col1
    }, "AgeCategory:"), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col2
    }, member.ageCategoryID)), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col1
    }, "Membership Number:"), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col2
    }, this.props.membershipNation && this.props.membershipNation.description, " / ", member.membershipNumber)), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col1
    }, "Membership Expires:"), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col2
    }, (0, _occasion.default)(member.membershipExpiryDate, 'D MMM YYYY'))), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col1
    }, "Membership Category:"), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col2
    }, member.membershipCategory)), /*#__PURE__*/_react.default.createElement(_row.default, null, /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col1
    }, "Gender:"), /*#__PURE__*/_react.default.createElement(_col.default, {
      sm: col2
    }, this.props.gender && this.props.gender.description || 'unknown')));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref3 = {
  description: true
};
var _ref4 = {
  description: true
};
var _default = exports.default = (0, _reactBicycle.connect)(ConfirmPukMembership, props => ({
  ["refCode(codeType:\"gender\",refCode:" + JSON.stringify(props.member.genderRef || props.scratchPaddler.genderRef) + ") as gender"]: _ref3,
  ["refCode(codeType:\"nation\",refCode:" + JSON.stringify(props.member.membershipNationRef) + ") as membershipNation"]: _ref4
}));